import styles from "./page.module.css";
import Header from "components/header/Header";
import StartPage from "./startPage/startPage";
import LogedinHeaderComponent from "components/logedinHeaderComponent/logedinHeaderComponent";
import { useEffect, useState } from "react";
import StatisticTabs from "./statistcPages/statisticDashboard";
import { useNavigate } from "react-router-dom";
import { checkSession } from "services/userLogin/check-session";

export default function StatisticPage() {
    const sections = [
        { id: "statistik", label: "Statistik" },
    ];
    const [activeSection, setActiveSection] = useState<string>('');
    const handleSectionClick = (tabId: string) => {
        setActiveSection(tabId);
    };
    const navigate = useNavigate();

    const verifySession = async () => {
        try {
            const sessionData = await checkSession();
            if (sessionData.session_active) {
                const { id, is_customer, is_employee, is_profile_completed, is_password_completed, has_kid, is_statistic } = sessionData.user_data;
                if (!is_customer) {
                    if (is_employee && is_statistic) {
                        if (is_password_completed) {
                            navigate('/reservierungsportal/StatisticPage', { replace: true });
                        } else {
                            navigate('/reservierungsportal/EmployHomePage', { replace: true });
                        }

                    } else {
                        navigate('/reservierungsportal', { replace: true });
                    }
                } else {
                    if (!is_profile_completed) {
                        navigate("/reservierungsportal/compliatProfile", { replace: true });
                    } else if (!has_kid) {
                        navigate("/reservierungsportal/NewkidsProfile", { replace: true });
                    } else {
                        navigate("/reservierungsportal/CustomerHomePage", { replace: true });

                    }
                }
            } else {
                navigate('/reservierungsportal', { replace: true });
            }
        } catch (error) {
            console.error("Fehler bei der Sitzungsprüfung:", error);
        }
    };
    useEffect(() => {
        verifySession();
    }, []);
    return (
        <div className={styles.page}>
            <Header>
                <LogedinHeaderComponent
                    sections={sections}
                    activeSection={activeSection}
                    onTabChange={handleSectionClick}
                    isWithSearch={false}
                />
            </Header>
            <main className={styles.main}>
                {activeSection === "" && (
                    <section>
                        <StartPage onNavigateToStatistik={() => handleSectionClick("statistik")} />
                    </section>
                )}
                {activeSection === "statistik" && (
                    <section>
                        <StatisticTabs />
                    </section>
                )}
            </main>
        </div>
    );
}
